"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ContentListModalHeadline_1 = require("./ContentListModalHeadline");
const ContentListModalLoader_1 = require("./ContentListModalLoader");
const ContentListModal_module_scss_1 = __importDefault(require("./ContentListModal.module.scss"));
function ContentListModal({ headlineContent, mainContent, sidebar }) {
    return (react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.overlay },
        react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.window },
            react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.modal },
                react_1.default.createElement(ContentListModalHeadline_1.ContentListModalHeadline, { headline: headlineContent }),
                react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.content, "data-column": !sidebar },
                    react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.mainContent, "data-variant": sidebar ? 'secondary' : 'primary' }, mainContent !== null && mainContent !== void 0 ? mainContent : react_1.default.createElement(ContentListModalLoader_1.ContentListModalBodyLoader, null)),
                    sidebar ? react_1.default.createElement("div", { className: ContentListModal_module_scss_1.default.sidebar }, sidebar) : null)))));
}
ContentListModal.defaultProps = {
    headlineContent: undefined,
    mainContent: undefined,
    sidebar: undefined,
};
exports.default = ContentListModal;
